module.exports = __webpack_public_path__ + "img/qr1.b6498a85.png";